import { createTheme } from "@mui/material/styles";
import { INTENSE_GRAY, PRIMARY, RED } from "../utils/colors";

export const configureDesignSystem = createTheme({
  palette: {
    primary: {
      main: PRIMARY,
    },
    secondary: {
      main: INTENSE_GRAY,
    },
    error: { main: RED },
  },

  typography: {
    fontFamily: "Montserrat",
    allVariants: {
      textTransform: "none",
      letterSpacing: "0.05em",
    },
  },
  shape: { borderRadius: 4 },
  spacing: 8,
});
